module.exports = __webpack_public_path__ + "static/media/mas.6ed255b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/mas.svg
// module id = 124
// module chunks = 0